import api from './axios';

const BASE = '/hardware';

// ── Categories ────────────────────────────────────────────
export const fetchCategories = () => api.get(`${BASE}/categories`);
export const createCategory = (data) => api.post(`${BASE}/categories`, data);
export const updateCategory = (id, data) => api.put(`${BASE}/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`${BASE}/categories/${id}`);

// ── Catalog ───────────────────────────────────────────────
export const fetchCatalog = (params) => api.get(`${BASE}/catalog`, { params });
export const fetchCatalogItem = (id) => api.get(`${BASE}/catalog/${id}`);
export const createCatalogItem = (data) => api.post(`${BASE}/catalog`, data);
export const updateCatalogItem = (id, data) => api.put(`${BASE}/catalog/${id}`, data);
export const deleteCatalogItem = (id) => api.delete(`${BASE}/catalog/${id}`);

// ── Requests ──────────────────────────────────────────────
export const fetchHardwareRequests = (params) => api.get(`${BASE}/requests`, { params });
export const fetchHardwareRequest = (id) => api.get(`${BASE}/requests/${id}`);
export const createHardwareRequest = (data) => api.post(`${BASE}/requests`, data);

// Lifecycle actions
export const managerApprove = (id, data) => api.patch(`${BASE}/requests/${id}/manager-approve`, data);
export const managerReject = (id, data) => api.patch(`${BASE}/requests/${id}/manager-reject`, data);
export const ictAccept = (id) => api.patch(`${BASE}/requests/${id}/ict-accept`);
export const ictReject = (id, data) => api.patch(`${BASE}/requests/${id}/ict-reject`, data);
export const requestMoreInfo = (id, data) => api.patch(`${BASE}/requests/${id}/request-info`, data);
export const startProvisioning = (id) => api.patch(`${BASE}/requests/${id}/start-provisioning`);
export const markReady = (id) => api.patch(`${BASE}/requests/${id}/mark-ready`);
export const markDelivered = (id) => api.patch(`${BASE}/requests/${id}/mark-delivered`);
export const employeeAccept = (id, data) => api.patch(`${BASE}/requests/${id}/employee-accept`, data);
export const employeeReject = (id, data) => api.patch(`${BASE}/requests/${id}/employee-reject`, data);
export const cancelRequest = (id, data) => api.patch(`${BASE}/requests/${id}/cancel`, data);
export const deleteHardwareRequest = (id) => api.delete(`${BASE}/requests/${id}`);

// ── Fulfilment Queue ──────────────────────────────────────
export const fetchFulfilmentQueue = (params) => api.get(`${BASE}/fulfilment`, { params });

// ── Request Asset Operations ──────────────────────────────
export const fetchAvailableAssets = (id, params) => api.get(`${BASE}/requests/${id}/available-assets`, { params });
export const reserveAssets = (id, assetIds) => api.patch(`${BASE}/requests/${id}/reserve-assets`, { assetIds });
export const refreshInventory = (id) => api.patch(`${BASE}/requests/${id}/refresh-inventory`);

// ── Procurement ───────────────────────────────────────────
export const fetchProcurementQueue = (params) => api.get(`${BASE}/procurement`, { params });
export const fetchProcurementRequest = (id) => api.get(`${BASE}/procurement/${id}`);
export const fetchProcurementAvailableAssets = (id, params) => api.get(`${BASE}/procurement/${id}/available-assets`, { params });
export const updateProcurementStatus = (id, data) => api.patch(`${BASE}/procurement/${id}`, data);

// ── Dashboard ─────────────────────────────────────────────
export const fetchHardwareDashboard = () => api.get(`${BASE}/dashboard`);

// ── Hardware Acceptance Form ──────────────────────────────
export const generateAcceptanceForm = (requestId, data) => api.post(`${BASE}/requests/${requestId}/acceptance-form`, data);
export const fetchAcceptanceForm = (requestId) => api.get(`${BASE}/requests/${requestId}/acceptance-form`);
export const fetchAcceptanceFormVersions = (requestId) => api.get(`${BASE}/requests/${requestId}/acceptance-form/versions`);
export const downloadAcceptanceFormPdf = (requestId) => api.get(`${BASE}/requests/${requestId}/acceptance-form/pdf`, { responseType: 'blob' });
export const signAcceptanceEmployee = (docId, data) => api.patch(`${BASE}/acceptance-documents/${docId}/sign-employee`, data);
export const signAcceptanceEngineer = (docId, data) => api.patch(`${BASE}/acceptance-documents/${docId}/sign-engineer`, data);
export const overrideCondition = (docId, data) => api.patch(`${BASE}/acceptance-documents/${docId}/override-condition`, data);
export const setAcceptanceCondition = (docId, data) => api.patch(`${BASE}/acceptance-documents/${docId}/condition`, data);
export const addAcceptanceComment = (docId, data) => api.post(`${BASE}/acceptance-documents/${docId}/comments`, data);
export const uploadAcceptancePhoto = (docId, formData) => api.post(`${BASE}/acceptance-documents/${docId}/photos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const fetchAcceptanceDocument = (docId) => api.get(`${BASE}/acceptance-documents/${docId}`);
export const downloadAcceptanceDocumentPdf = (docId) => api.get(`${BASE}/acceptance-documents/${docId}/pdf`, { responseType: 'blob' });
export const cancelAcceptanceDocument = (docId) => api.patch(`${BASE}/acceptance-documents/${docId}/cancel`);
export const fetchAcceptanceDocuments = (params) => api.get(`${BASE}/acceptance-documents`, { params });
export const fetchRecoveryLiability = (assetId) => api.get(`${BASE}/recovery-liability/${assetId}`);
export const fetchAcceptancePolicy = () => api.get(`${BASE}/acceptance-policy`);
export const fetchMyPendingForms = () => api.get(`${BASE}/my-pending-forms`);
export const fetchMyFormsHistory = (params) => api.get(`${BASE}/my-forms-history`, { params });
export const updateAcceptancePolicyTerms = (data) => api.post(`${BASE}/acceptance-policy/terms`, data);
export const updateAcceptancePolicyRecovery = (data) => api.post(`${BASE}/acceptance-policy/recovery`, data);
export const fetchAcceptancePolicyHistory = (params) => api.get(`${BASE}/acceptance-policy/history`, { params });
